import { Component, ElementRef, HostListener, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { UrlService } from '../../services/url.service';
import { AmenitiesService } from '../../services/amenities.service';
import { ApiClientService } from '../../services/api-client.service';
import { AuthenticationService } from '../../services/authentication.service';

declare const toastr: any;

@Component({
    selector: 'settings-integrations-filter',
    templateUrl: './settings-integrations-filter.component.html',
    styleUrls: ['./settings-integrations-filter.component.scss']
})
export class SettingsIntegrationsFilterComponent implements OnInit {
    showDropdown = false;
    @Output() onAmenitiesChange: EventEmitter<any> = new EventEmitter();

    @ViewChild('approvedCheckbox') approved: ElementRef;
    @ViewChild('pendingCheckbox')  pending:  ElementRef;
    @ViewChild('expiredCheckbox')  expired:  ElementRef;
    @ViewChild('declinedCheckbox') declined: ElementRef;
    constructor(private urlService: UrlService,
        public amenitiesService: AmenitiesService,
        public api: ApiClientService,
        public authenticationService: AuthenticationService,
    ) { }

    ngOnInit() {
        this.urlService.onUrlChange.subscribe(_ => {
            const status = this.urlService.queryParams['status'];
            if (status) {
                this.approved.nativeElement.checked = status.indexOf('approved') !== -1;
                this.pending.nativeElement.checked = status.indexOf('pending') !== -1;
                this.expired.nativeElement.checked = status.indexOf('expired') !== -1;
                this.declined.nativeElement.checked = status.indexOf('declined') !== -1;
            } else {
                this.approved.nativeElement.checked = false;
                this.pending.nativeElement.checked = false;
                this.expired.nativeElement.checked = false;
                this.declined.nativeElement.checked = false;
            }
        });
    }

    changeFilter() {
        const approvedValue = this.approved.nativeElement.checked;
        const pendingValue = this.pending.nativeElement.checked;
        const expiredValue = this.expired.nativeElement.checked;
        const declinedValue = this.declined.nativeElement.checked;

        if (!approvedValue && !pendingValue && !expiredValue && !declinedValue) {
            this.urlService.queryParams['status'] = null;
        } else {
            let status = '';
            if (approvedValue) status += 'approved,';
            if (pendingValue) status += 'pending,';
            if (expiredValue) status += 'expired,';
            if (declinedValue) status += 'declined,';
            this.urlService.queryParams['status'] = status.slice(0, -1);
        }
        this.urlService.setQueryParams(null, 1);
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('settings-integrations-filter')) this.showDropdown = false;
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/settings-integrations-filter/settings-integrations-filter.component.ts